import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import { selectOverlay } from 'ducks/overlays/selectors';
import { Icon } from 'framework/Icon';
import { Tooltip } from 'framework/Tooltip';
import { useAppSelector } from 'store/hooks';

import { EMPTY_FUNCTION } from '../../constants';

import cn from './Drawer.module.scss';

export const DrawerAction = ({
  onClick = EMPTY_FUNCTION,
  information,
  icon,
  border = false,
}: {
  onClick: () => void;
  information: string;
  icon: IconDefinition;
  border?: boolean;
}) => {
  const { is_open } = useAppSelector(selectOverlay('drawer'));
  return (
    <Tooltip information={is_open ? '' : information}>
      <div
        onClick={onClick}
        className={classNames(cn.action, 'transition', { [cn.border]: border })}
      >
        <Icon size="14px" width="50px" icon={icon} />
        <p>{information}</p>
      </div>
    </Tooltip>
  );
};
